import { useQuery } from '@apollo/client';
import { LOAD_METRIC_DEFINITION_BY_ID } from '../gqlSchemes/getMetricDefinitionById';


const useLoadMetricDefinitionById = (id) => {
  const { data, loading, error } = useQuery(
    LOAD_METRIC_DEFINITION_BY_ID,
    {
      fetchPolicy: 'no-cache',
      variables: {
        page: 0,
        perPage: 20,
        id
      }
    }
  );

  if (error) console.error(error);

  return {
    data,
    components: data?.metric?.metricDefinition?.metricDefinitionById?.components,
    loading,
    error
  };
};

export default useLoadMetricDefinitionById;